import type { TablePluginViewerConfig } from './types';

export const DEFAULTS: TablePluginViewerConfig = Object.freeze({});
